module.exports = __webpack_public_path__ + "img/55.f2f589c5.png";